<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/receivableList' }">应收</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="update">编辑</el-button>
                    <draggableDetail :draggable="{ data_name: 'receivable' }" @isErrshow="reload"></draggableDetail>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="
                                                in_array(item.prop, [
                                                    'supplier',
                                                    'demander',
                                                    'partner',
                                                    'product',
                                                    'partner_current',
                                                    'person1',
                                                    'person2',
                                                    'ppa_code'
                                                ])
                                            "
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="调整行" name="2">
                    <vReceivableAdjustmentLineListComponent
                        v-if="flag"
                        :postList="receivable_adjustment_line_params"
                    ></vReceivableAdjustmentLineListComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="绩效分配" name="3">
                    <vPerformanceAssignmentComponent
                        v-if="flag"
                        :postList="performance_assignment_params"
                    ></vPerformanceAssignmentComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
import vReceivableAdjustmentLineListComponent from '../../listComponent/basicdata/receivableAdjustmentLine/receivableAdjustmentLineComponent.vue';
import vPerformanceAssignmentComponent from '../../listComponent/basicdata/performance/performanceAssignmentComponent.vue';

export default {
    inject: ['reload'],
    name: 'receivableDetail',
    components: {
        draggableDetail,
        vReceivableAdjustmentLineListComponent,
        vPerformanceAssignmentComponent
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2', '3'],
            data: {},
            queryParams: {},
            headerTitle: '应收详情',
            flag: false,
            receivable_adjustment_line_params: {},
            performance_assignment_params: {}
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.initSubListParams();
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
        });
    },
    methods: {
        in_array,
        initSubListParams() {
            this.receivable_adjustment_line_params.params = {
                receivable_rid: this.queryParams.rid
            };
            this.performance_assignment_params.params = {
                object_rid: this.queryParams.rid,
                object_type_code: 2
            };
        },
        toDetail(prop) {
            if (prop == 'supplier' && this.data.supplier_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.supplier_rid
                    }
                });
            } else if (prop == 'demander' && this.data.demander_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.demander_rid
                    }
                });
            } else if (prop == 'partner' && this.data.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: this.data.partner_rid
                    }
                });
            } else if (prop == 'product' && this.data.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.product_rid
                    }
                });
            } else if (prop == 'partner_current' && this.data.partner_current_rid != '') {
                this.$router.push({
                    path: '/partnerCurrentDetail',
                    query: {
                        id: this.data.partner_current_rid
                    }
                });
            } else if (prop == 'person1' && this.data.person1_rid != '') {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: this.data.person1_rid
                    }
                });
            } else if (prop == 'person2' && this.data.person2_rid != '') {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: this.data.person2_rid
                    }
                });
            } else if (prop == 'ppa_code' && this.data.ppa_rid != '') {
                this.$router.push({
                    path: '/partnerProductAccountDetail',
                    query: {
                        id: this.data.ppa_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).receivable;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .receivableDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.code;
                })
                .catch((error) => {});
        },
        //前往编辑页面
        update() {
            this.$router.push({
                path: 'receivableEdit',
                query: {
                    type: 'update',
                    id: this.queryParams.rid
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>